interface OptionButtonProps {
  label: string;
  state: "default" | "selected" | "correct" | "incorrect";
  disabled: boolean;
  onClick?: () => void;
}

const stateClasses = {
  default: "border-gray-200 bg-white hover:border-navy-300 hover:bg-navy-50",
  selected: "border-navy-500 bg-navy-50 ring-2 ring-navy-200",
  correct: "border-green-500 bg-green-50 ring-2 ring-green-200",
  incorrect: "border-red-500 bg-red-50 ring-2 ring-red-200",
} as const;

const stateIcons = {
  default: null,
  selected: null,
  correct: "✓",
  incorrect: "✗",
} as const;

export function OptionButton({ label, state, disabled, onClick }: OptionButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`flex w-full min-h-[44px] items-center rounded-lg border-2 px-4 py-3 text-left text-sm font-medium transition-all
        ${stateClasses[state]}
        ${disabled ? "cursor-not-allowed opacity-75" : "cursor-pointer"}
      `}
    >
      {stateIcons[state] && (
        <span className={`mr-3 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white ${state === "correct" ? "bg-green-500" : "bg-red-500"}`}>
          {stateIcons[state]}
        </span>
      )}
      <span className={state === "correct" ? "text-green-700 font-semibold" : state === "incorrect" ? "text-red-700" : "text-gray-700"}>
        {label}
      </span>
    </button>
  );
}
